import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import "./i18n"; // initialise i18next (side-effect import)
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Cursor from "./components/Cursor";
import ErrorBoundary from "./components/shared/ErrorBoundary";
import Home from "./pages/Home";
import Listings from "./pages/Listings";
import PropertyDetail from "./pages/PropertyDetail";
import About from "./pages/About";
import Contact from "./pages/Contact";
import International from "./pages/International";
import InternationalDetail from "./pages/InternationalDetail";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

export default function App() {
  return (
    <HelmetProvider>
    <BrowserRouter>
      <Cursor />
      <div className="noise" />
      <Navbar />
      <ScrollTop />
      <ErrorBoundary>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/listings" element={<Listings />} />
        <Route path="/property/:slug" element={<PropertyDetail />} />
        <Route path="/international" element={<International />} />
        <Route path="/international/:slug" element={<InternationalDetail />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="*" element={
          <main style={{padding:"12rem 5rem",textAlign:"center"}}>
            <h1 style={{fontFamily:"'Cormorant Garamond',serif",fontSize:"80px",fontWeight:300,marginBottom:"1rem"}}>404</h1>
            <a href="/" style={{color:"var(--gold)",fontSize:"12px",letterSpacing:".14em",textTransform:"uppercase"}}>← Go home</a>
          </main>
        } />
      </Routes>
      </ErrorBoundary>
      <Footer />
    </BrowserRouter>
    </HelmetProvider>
  );
}
